import { render, staticRenderFns } from "./AboutTheHukosWrapper.vue?vue&type=template&id=67c51e02&lang=pug&"
import script from "./AboutTheHukosWrapper.vue?vue&type=script&lang=js&"
export * from "./AboutTheHukosWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports